import * as $ from "jquery";

import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  NgModule,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
// import { MonacoEditorModule } from "ngx-monaco-editor-v2";

import { AppRoutingModule } from "./routing/app-routing.module";

// Imports for loading & configuring the in-memory web api
import { FroalaEditorModule } from "../froala/editor/editor.module";
import { FroalaViewModule } from "../froala/view/view.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ClipboardModule } from "ngx-clipboard";
import { TagInputModule } from "ngx-chips";

import { LazyLoadImageModule } from "ng-lazyload-image";
import { MainComponent } from "@components/main.component";
import { InlineTextEditorComponent } from "@components/common/inline-text-editor.component";
import { ProgressBarComponent } from "@components/common/progress-bar.component";
import { GoldenLayoutBaseComponent } from "@components/editor/workspace/golden-layout-base.component";
import {
  GoldenLayoutTextComponent,
  ReplaceBusinessTagsPipe,
} from "@components/editor/workspace/golden-layout-text.component";
import {
  GoldenLayoutListingInformationComponent,
  ReplaceListingTagsPipe,
} from "@app/components/editor/workspace/golden-layout-listing-information.component";
import {
  GoldenLayoutListingImageComponent,
  RenderImagesPipe,
} from "@components/editor/workspace/golden-layout-listing-image.component";
// import { AdImageComponent } from '@components/editor/workspace/ad-image.component';
import { PlatformComponent } from "@components/platform/platform.component";
import { CatalogsComponent } from "@components/platform/catalogs.component";
import { CatalogsListComponent } from "@components/platform/catalogs.list.component";
import { SettingsComponent } from "@components/platform/settings.component";
import { PageNotFoundComponent } from "@components/misc/page-not-found.component";
import { CatalogsCreateComponent } from "@components/platform/catalogs.create.component";
import { ButtonCircleSaveComponent } from "@components/common/button-circle-save.component";
import { MasonryDirective } from "@directives/masonry.directive";
import { DroppableDirective } from "@directives/droppable.directive";
import { DraggableDirective } from "@directives/draggable.directive";
import { ResizableDirective } from "@directives/resizable.directive";
import { CatalogService } from "@services/catalog.service";
import { CookieService } from "ngx-cookie-service";
import { LayoutService } from "@services/layout.service";
import { SoundService } from "@services/sound.service";
import { WindowService } from "@services/window.service";
import { UserService } from "@services/user.service";
import { LoaderService } from "@services/loader.service";
import { AuthenticationService } from "@services/authentication.service";
import { AuthenticationGuardService } from "@services/authentication-guard.service";
import { SwitchToBetaComponent } from "@components/switch-to-beta.component";
import {
  DropzoneModule,
  DROPZONE_CONFIG,
  DropzoneConfigInterface,
} from "ngx-dropzone-wrapper";
import { ListingService } from "@app/services/listing.service";
import { RichTextEditorComponent } from "@app/components/editor/workspace/rich-text-editor.component";
import "hammerjs";
import { PraiseService } from "@app/services/praise.service";
import { ProgressService } from "@app/services/progress.service";
import { SupermodalComponent } from "@app/components/common/supermodal.component";
import { SubmitButtonComponent } from "@app/components/common/submit-button.component";
import { Angulartics2Module } from "angulartics2";
// import { MoonwalkComponent } from '@app/components/common/moonwalk.component';
import { MessengerService } from "@app/services/messenger.service";
import { MessengerComponent } from "@app/components/common/messenger.component";
import { ProductsComponent } from "@app/components/platform/products.component";
import { ExpirationGuardService } from "@app/services/expiration-guard.service";
// import { InteractDraggableDirective } from '@app/directives/interact-draggable.directive';
// import { InteractResizableDirective } from '@app/directives/interact-resizable.directive';
import { CatalogBuilderGuardService } from "@app/services/catalog-builder-guard.service";
import { CatalogsInstallComponent } from "@app/components/platform/catalogs.install.component";
import { SessionGuardService } from "@app/services/session-guard.service";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { SurveyComponent } from "@app/components/common/survey.component";
import { WelcomeComponent } from "@app/components/platform/welcome.component";
import { WelcomeGuardService } from "@app/services/welcome-guard.service";
import { SupermodalSuccessComponent } from "@app/components/common/supermodal-success.component";
import { RootGuardService } from "@app/services/root-guard.service";
import { LoadingComponent } from "@app/components/loading.component";
import { TearSheetComponent } from "@app/components/platform/tear-sheet.component";
import { ColorCompactModule } from "ngx-color/compact";
import { FontPickerModule } from "ngx-font-picker";
import { FONT_PICKER_CONFIG } from "ngx-font-picker";
import { FontPickerConfigInterface } from "ngx-font-picker";
import {
  SafeHTMLPipe,
  SafeResourceUrlPipe,
  SafeUrlPipe,
} from "@app/pipe/safe.pipe";
import { TruncatePipe } from "@app/pipe/truncate.pipe";
import { PricePipe } from "@app/pipe/price.pipe";
import { FeatureRequestService } from "@app/services/feature-request.service";
import { FeatureRequestsComponent } from "@app/components/platform/feature-requests.component";
import { FileService } from "@app/services/file.service";
import { TearSheetGuardService } from "@app/services/tear-sheet-guard.service";
import { OrderSheetGuardService } from "@app/services/order-sheet-guard.service";
import { OrderSheetComponent } from "@app/components/platform/order-sheet.component";
import { RequestInviteComponent } from "@app/components/platform/request-invite.component";
import { CompleteOrderComponent } from "@app/components/platform/complete-order.component";
import { ListingCartItem } from "shopping/cart";
import { ShoppingCartComponent } from "@app/components/platform/shopping-cart.component";
import {
  DigitalOrderSheetViewComponent,
  OptimalImagePipe,
} from "@app/components/platform/digital-order-sheet.view.component";
import { OrderSheetsComponent } from "@app/components/platform/order-sheets.component";
import { OrderSheetsListComponent } from "@app/components/platform/order-sheets.list.component";
import { CatalogOrderSheetDownloadComponent } from "@app/components/platform/catalog-order-sheet.download.component";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { GoldenLayoutConfigurationComponent } from "@app/components/editor/workspace/golden-layout-configuration.component";
import { CurrencyPipe, NgOptimizedImage } from "@angular/common";
import {
  GoldenLayoutListingTableComponent,
  RenderTablePipe,
} from "./components/editor/workspace/golden-layout-listing-table.component";
import { FroalaTagsEditorComponent } from "./components/editor/workspace/froala-tags-editor.component";
import { BorderEditorComponent } from "./components/editor/workspace/border-editor.component";
import { CustomerService } from "@app/services/customer.service";
import { BarcodeComponent } from "./components/platform/barcode.component";
import {
  GoldenLayoutListingBarcodeComponent,
  RenderBarcodePipe,
} from "./components/editor/workspace/golden-layout-listing-barcode.component";
import { ResourceService } from "@app/services/resource.service";
import { TutorialVideosComponent } from "@app/components/platform/tutorial-videos.component";
import { YouTubePlaylistComponent } from "@app/components/platform/youtube-playlist.component";
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from "@danielmoncada/angular-datetime-picker";
import { OrderService } from "@app/services/order.service";
import { YouTubeService } from "@app/services/youtube.service";
import { PlaygroundComponent } from "@app/components/platform/playground.component";
import { ListingsSelectorComponent } from "@app/components/common/listings-selector.component";
import { InventoryComponent } from "@app/components/platform/inventory.component";
import { BulkImportComponent } from "@app/components/platform/bulk-import.component";
import { LoadingButtonDirective } from "@app/directives/loading-button.directive";
import {
  ListingsTableComponent,
  InlineFroalaComponent,
} from "@app/components/platform/listings-table.component";
import { InventoryListComponent } from "@app/components/platform/inventory-list.component";
import { DigitalOrderSheetConfigurationComponent } from "@app/components/platform/digital-order-sheet-configuration.component";
import { InventoryTagComponent } from "@app/components/platform/inventory-tag.component";
import {
  GoldenLayoutListingQRCodeComponent,
  RenderQRCodePipe,
} from "@app/components/editor/workspace/golden-layout-listing-qrcode.component";
import { FlipbookComponent } from "@app/components/platform/flipbook.component";
import { HomeComponent } from "@app/components/platform/home.component";
import { DigitalOrderSheet } from "./data/digital-order-sheet";
import { DigitalOrderSheetService } from "./services/digital-order-sheet.service";
import { DigitalOrderSheetComponent } from "./components/platform/digital-order-sheet.component";
import { CatalogOrderSheetViewComponent } from "./components/platform/catalog-order-sheet.view.component";
import { AutofocusDirective } from "./directives/autofocus.directive";
import { ImagePipe } from "./pipe/image.pipe";
import { CouponService } from "./services/coupon.service";
import { GADateRangeSelectorComponent } from "./components/common/ga-date-range-selector.component";
import { DashboardComponent } from "./components/platform/dashboard.component";
import { GAChartComponent } from "./components/common/ga-chart.component";
import { GAReportComponent } from "./components/common/ga-report.component";
import { GALoginButtonComponent } from "./components/common/ga-login-button.component";
import { TimeSincePipe } from "./pipe/time-since.pipe";
import { UpgradeComponent } from "./components/platform/upgrade.component";
import { GlobalSettingsService } from "./services/global-settings.service";
import { CartService } from "../shopping/cart.service";
import { GoldenLayoutModule } from "golden-layout/golden-layout.module";
import {
  GoldenLayoutConfig,
  GOLDEN_LAYOUT_CONFIG,
} from "golden-layout/golden-layout.interfaces";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ShoppingCartModule } from "shopping/shoping-cart.module";
import {
  DynamicListModule,
  NISTemplateModule,
  RemoteDataService,
  WizardModule,
} from "@nowinstore/nowinstore-core-ui/components";
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from "primeng/inputtext";
import { RadioButtonModule } from "primeng/radiobutton";
import { ToastService } from "./services/toast.service";
import { MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { CatalogAddComponent } from "./components/platform/catalog-add.component";
import { CardModule } from "primeng/card";
import { CatalogListingsEditorComponent } from "./components/listings-picker/catalog-listings-editor.component";
import { TreeTableModule } from "primeng/treetable";
import { TreeModule } from "primeng/tree";
import { ThemeCreatorModule } from "./components/theme-creator/theme-creator.module";
import { CssService } from "./services/css.service";
import { TemplateLoaderService } from "./services/template-loader.service";
import { ImageModule } from "primeng/image";
import { TooltipModule } from "primeng/tooltip";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { PaginatorModule } from "primeng/paginator";
import { AssetsPickerComponent } from "./components/catalog-editor/assets-picker.component";
import { ThemeEditorComponent } from "./components/catalog-editor/theme-editor.component";
import { ThemeEditorPanelComponent } from "./components/catalog-editor/theme-editor-panel.component";
import { TabViewModule } from "primeng/tabview";
import { CaptionEditorComponent } from "./components/catalog-editor/caption-editor.component";
import { SVGEditorComponent } from "./components/catalog-editor/svg-editor.component";
import { OptionSelectorComponent } from "./components/platform/option-selector.component";
import { GalleriaModule } from "primeng/galleria";
import { ListingsPickerComponent } from "./components/listings-picker/listings-picker.component";
import { SelectionIndicatorComponent } from "./components/platform/selection-indicator.component";
import { ProgressBarModule } from "primeng/progressbar";
import { BrandEditorPanelComponent } from "./components/catalog-editor/brand-editor-panel.component";
import { SVGEditorPanelComponent } from "./components/catalog-editor/svg-editor-panel.component";
import { Router } from "@angular/router";

// @ts-ignore
String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, "g"), replacement);
};

const DEFAULT_FONT_PICKER_CONFIG: FontPickerConfigInterface = {
  // Change this to your Google API key
  apiKey: "AIzaSyDHuv5t9LpuiquNf3thQuZjGUi1xArgFO0",
};

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Change this to your upload POST address:
  url: "https://httpbin.org/post",
  maxFilesize: 50,
  acceptedFiles: "image/*",
};
const DEFAULT_GOLDEN_LAYOUT_CONFIG: GoldenLayoutConfig = new GoldenLayoutConfig(
  {}
);

@NgModule({
  imports: [
    PlaygroundComponent,
    CatalogAddComponent,
    NgOptimizedImage,
    ProgressBarModule,
    CatalogListingsEditorComponent,
    BrandEditorPanelComponent,
    OptionSelectorComponent,
    ListingsPickerComponent,
    SVGEditorComponent,
    SVGEditorPanelComponent,
    AssetsPickerComponent,
    ThemeEditorComponent,
    ThemeEditorPanelComponent,
    ImageModule,
    CardModule,
    InputTextModule,
    RadioButtonModule,
    CheckboxModule,
    SelectionIndicatorComponent,
    WizardModule,
    FormsModule,
    NgxDatatableModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    LazyLoadImageModule,
    BrowserModule,
    // MonacoEditorModule.forRoot(),
    NgbModule,
    ClipboardModule,
    HttpClientModule,
    ColorCompactModule,
    BrowserAnimationsModule,
    ButtonModule,
    TooltipModule,
    FontAwesomeModule,
    ToastModule,
    // InMemoryWebApiModule.forRoot(InMemoryDataService, { delay: 500, apiBase: 'api/v2' }),
    AppRoutingModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    ReactiveFormsModule,
    DropzoneModule,
    TabViewModule,
    TreeTableModule,
    NISTemplateModule,
    ThemeCreatorModule,
    TreeModule,
    DynamicListModule,
    PaginatorModule,
    GoldenLayoutModule,
    GalleriaModule,
    DialogModule,
    ShoppingCartModule.forRoot({
      itemType: ListingCartItem,
      serviceType: "localStorage",
      serviceOptions: {
        storageKey: "NgShoppingCart",
        clearOnError: true,
      },
    }),
    TagInputModule,
    InfiniteScrollModule,
    FontPickerModule,
    Angulartics2Module.forRoot({
      pageTracking: {
        clearIds: true,
        clearQueryParams: true,
      },
    }),
  ],
  declarations: [
    CaptionEditorComponent,
    HomeComponent,
    SafeHTMLPipe,
    AutofocusDirective,
    ImagePipe,
    TimeSincePipe,
    SafeResourceUrlPipe,
    SafeUrlPipe,
    RenderImagesPipe,
    OptimalImagePipe,
    RenderTablePipe,
    ReplaceBusinessTagsPipe,
    ReplaceListingTagsPipe,
    RenderBarcodePipe,
    RenderQRCodePipe,
    TruncatePipe,
    PricePipe,
    MainComponent,
    CatalogOrderSheetViewComponent,
    GoldenLayoutConfigurationComponent,
    PlatformComponent,
    LoadingButtonDirective,
    MasonryDirective,
    DraggableDirective,
    DroppableDirective,
    // InteractDraggableDirective,
    // InteractResizableDirective,
    ResizableDirective,
    CatalogsComponent,
    CatalogsListComponent,
    CatalogsCreateComponent,
    InlineTextEditorComponent,
    ProgressBarComponent,
    SettingsComponent,
    PageNotFoundComponent,
    GoldenLayoutBaseComponent,
    GoldenLayoutListingImageComponent,
    GoldenLayoutListingInformationComponent,
    GoldenLayoutListingTableComponent,
    GoldenLayoutListingBarcodeComponent,
    GoldenLayoutListingQRCodeComponent,
    GoldenLayoutTextComponent,
    InventoryComponent,
    InventoryListComponent,

    // AdImageComponent,
    SwitchToBetaComponent,
    RichTextEditorComponent,
    SupermodalComponent,
    SupermodalSuccessComponent,
    DigitalOrderSheetConfigurationComponent,
    GALoginButtonComponent,
    DashboardComponent,
    InventoryTagComponent,
    BulkImportComponent,
    ListingsTableComponent,
    SubmitButtonComponent,
    // MoonwalkComponent,
    MessengerComponent,
    ProductsComponent,
    CatalogsInstallComponent,
    LoadingComponent,
    SurveyComponent,
    TearSheetComponent,
    OrderSheetComponent,
    WelcomeComponent,
    RequestInviteComponent,
    FeatureRequestsComponent,
    DigitalOrderSheetComponent,
    DigitalOrderSheetViewComponent,
    OrderSheetsComponent,
    CatalogOrderSheetDownloadComponent,
    OrderSheetsListComponent,
    CompleteOrderComponent,
    ShoppingCartComponent,
    ButtonCircleSaveComponent,
    FroalaTagsEditorComponent,
    BorderEditorComponent,
    BarcodeComponent,
    TutorialVideosComponent,
    YouTubePlaylistComponent,
    ListingsSelectorComponent,
    InlineFroalaComponent,
    FlipbookComponent,
    GAChartComponent,
    GAReportComponent,
    GADateRangeSelectorComponent,
    UpgradeComponent,
  ],
  providers: [
    CssService,
    TemplateLoaderService,
    GlobalSettingsService,
    CouponService,
    OrderService,
    DigitalOrderSheetService,
    CustomerService,
    CatalogService,
    SoundService,
    WindowService,
    UserService,
    LoaderService,
    ListingService,
    FileService,
    LayoutService,
    AuthenticationService,
    AuthenticationGuardService,
    PraiseService,
    ProgressService,
    CookieService,
    MessengerService,
    TearSheetGuardService,
    OrderSheetGuardService,
    ExpirationGuardService,
    CatalogBuilderGuardService,
    SessionGuardService,
    WelcomeGuardService,
    RootGuardService,
    FeatureRequestService,
    GoldenLayoutService,
    CurrencyPipe,
    ResourceService,
    YouTubeService,
    ToastService,
    MessageService,
    RemoteDataService,
    // MockServerResultsService,
    // MockBackendProvider,
    // MockBackend,
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG,
    },
    {
      provide: GOLDEN_LAYOUT_CONFIG,
      useValue: DEFAULT_GOLDEN_LAYOUT_CONFIG,
    },
    {
      provide: FONT_PICKER_CONFIG,
      useValue: DEFAULT_FONT_PICKER_CONFIG,
    },
    // Sentry error handler / tracing removed along with Sentry.init().
    // {
    //   provide: ErrorHandler,
    //   useClass: MessengerService
    // }
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: APIInterceptor,
    //   multi: true,
    // }
  ],
  bootstrap: [MainComponent],
})
export class AppModule {}
